import React from "react";
import { Box } from "@mui/material";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "../input/validation.js";
import "../input/DatePicker.js";
import "../input/DateRangePicker.js";
import "../input/StyledInput.js";
import { FormTextInputCleanable } from "../input/FormInput.js";
import "../input/StyledFormInputHoc.js";
import "moment-timezone";
import "react-intl";
import "../input/DateSinglePicker.localize.js";
import "../input/hooks.js";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
function FormAutocompleteInput({ value, onInputChange, onBlur, clear, placeholder, onKeyDown }) {
  const { classes: styles } = useAutocompleteClasses();
  return /* @__PURE__ */ React.createElement(
    FormTextInputCleanable,
    {
      startAdornment: /* @__PURE__ */ React.createElement(Box, { component: "span", className: `${CustomIcon.Search} ${styles.autocompleteInputAdornment}` }),
      className: styles.autocompleteInput,
      value,
      onChange: (e) => onInputChange(e, e.target.value),
      onBlur,
      clear,
      placeholder,
      onKeyDown
    }
  );
}
export {
  FormAutocompleteInput
};
//# sourceMappingURL=FormAutocompleteInput.js.map
